import React, { useEffect, lazy, Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import AOS from 'aos';
import 'aos/dist/aos.css';

import { trackPageView } from "./utils/analytics";

const Home = lazy(() => import("./pages/Home"));
const AboutUs = lazy(() => import("./pages/AboutUs"));
const Blogs = lazy(() => import("./pages/Blogs"));

const CasinoGroups = lazy(() => import("./pages/CasinoGroups"));
const CasinoReviews = lazy(() => import("./pages/CasinoReviews"));
const Providers = lazy(() => import("./pages/Providers"));
const MobileCasinos = lazy(() => import("./pages/MobileCasinos"));
const CryptoCasinos = lazy(() => import("./pages/CryptoCasinos"));
const CryptoCoins = lazy(() => import("./pages/CryptoCoins"));
const LiveCasinos = lazy(() => import("./pages/LiveCasinos"));
const CasinosByCountry = lazy(() => import("./pages/CasinosByCountry"));
const VpnCasinos = lazy(() => import("./pages/VpnCasinos"));
const CasinosByLicence = lazy(() => import("./pages/CasinosByLicence"));
const CasinosByCurrency = lazy(() => import("./pages/CasinosByCurrency"));
const PaymentMethods = lazy(() => import("./pages/PaymentMethods"));
const CasinoBonuses = lazy(() => import("./pages/CasinoBonuses"));
const WelcomeBonuses = lazy(() => import("./pages/WelcomeBonuses"));
const NoDepositBonuses = lazy(() => import("./pages/NoDepositBonuses"));
const Cashback = lazy(() => import("./pages/Cashback"));
const NoWagering = lazy(() => import("./pages/NoWagering"));
const HighRoller = lazy(() => import("./pages/HighRoller"));
const ReloadBonuses = lazy(() => import("./pages/ReloadBonuses"));
const BonusesByCountry = lazy(() => import("./pages/BonusesByCountry"));
const CasinoGames = lazy(() => import("./pages/CasinoGames"));
const BaccaratGames = lazy(() => import("./pages/BaccaratGames"));
const BlackjackGames = lazy(() => import("./pages/BlackjackGames"));
const OnlinePoker = lazy(() => import("./pages/OnlinePoker"));
const SloteGames = lazy(() => import("./pages/SlotGames"));
const RouletteGames = lazy(() => import("./pages/RouletteGames"));
const LiveCasinoGames = lazy(() => import("./pages/LiveCasinoGames"));
const Streaming = lazy(() => import("./pages/Streaming"));
const About = lazy(() => import("./pages/About"));
const Author = lazy(() => import("./pages/Author"));
const Contact = lazy(() => import("./pages/Contact"));
const CookiePolicy = lazy(() => import("./pages/CookiePolicy"));
const MGALicensedCasinos = lazy(() => import("./pages/MGALicensedCasinos"));
const Footer = lazy(() => import("./components/Footer"));
const KahnawakeLicensedCasinos = lazy(() => import("./pages/KahnawakeLicensedCasinos"));
const CuracaoLicensedCasinos = lazy(() => import("./pages/CuracaoLicensedCasinos"));
const CasionGamesProviders = lazy(() => import("./pages/CasionGamesProviders"));
const CasinoRewardsCasinos = lazy(() => import("./pages/CasinoRewardsCasinos"));
const AllDamaNVCasinos = lazy(() => import("./pages/AllDamaNVCasinos"));
const NewPragmaticPlayCasinos = lazy(() => import("./pages/NewPragmaticPlayCasinos"));
const NewEcopayzCasinos = lazy(() => import("./pages/NewEcopayzCasinos"));
const PaysafecardTrueOnlineCasinos = lazy(() => import("./pages/PaysafecardTrueOnlineCasinos"));
const BestEvolutionGamingCasinos = lazy(() => import("./pages/BestEvolutionGamingCasinos"));
const RabidiNvCasinos = lazy(() => import("./pages/RabidiNvCasinos"));
const CasinoDetails = lazy(() => import("./pages/CasinoDetails"));
const Login = lazy(() => import("./pages/Login"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const CasinosAdmin = lazy(() => import("./pages/CasinosAdmin"));
const BlogsAdmin = lazy(() => import("./pages/BlogsAdmin"));
const SettingsAdmin = lazy(() => import("./pages/SettingsAdmin"));
const CreateCasino = lazy(() => import("./pages/CreateCasino"));
const CreateBlog = lazy(() => import("./pages/CreateBlog"));
const EditCasino = lazy(() => import("./pages/EditCasino"));
const EditBlog = lazy(() => import("./pages/EditBlog"));
const CasinoDetail = lazy(() => import("./pages/CasinoDetail"));

const menuItems = [
  { name: 'Home', path: '/', submenu: [] },
  {
    name: 'Casino',
    submenu: [
      { name: 'Casino Groups', path: '/casino-groups' },
      { name: 'Casino Reviews', path: '/casino-reviews' },
      { name: 'Providers', path: '/providers' },
      { name: 'Mobile Casinos', path: '/mobile-casinos' },
      { name: 'Crypto Casinos', path: '/crypto-casinos' },
      { name: 'Crypto Coins', path: '/crypto-coins' },
      { name: 'Live Casinos', path: '/live-casinos' },
      { name: 'Casinos By Country', path: '/casinos-by-country' },
      { name: 'Vpn Casinos', path: '/vpn-casinos' },
      { name: 'Casinos By Licence', path: '/casinos-by-licence' },
      { name: 'Casinos By Currency', path: '/casinos-by-currency' },
      { name: 'Payment Methods', path: '/payment-methods' },
    ],
  },
  {
    name: 'Bonuses',
    submenu: [
      { name: 'Casino Bonuses', path: '/casino-bonuses' },
      { name: 'Welcome Bonuses', path: '/welcome-bonuses' },
      { name: 'No Deposit Bonuses', path: '/no-deposit-bonuses' },
      { name: 'Cashback', path: '/cashback' },
      { name: 'No Wagering', path: '/no-wagering' },
      { name: 'High Roller', path: '/high-roller' },
      { name: 'Reload Bonuses', path: '/reload-bonuses' },
      { name: 'Bonuses By Country', path: '/bonuses-by-country' },
    ],
  },
  {
    name: 'Games',
    submenu: [
      { name: 'Casino Games', path: '/casino-games' },
      { name: 'Baccarat Games', path: '/baccarat-games' },
      { name: 'Black jack Games', path: '/blackjack-games' },
      { name: 'Online Poker', path: '/online-poker' },
      { name: 'Slote Games', path: '/slote-games' },
      { name: 'Roulette Games', path: '/roulette-games' },
      { name: 'Live Casino Games', path: '/live-casino-games' },
    ],
  },
  {
    name: 'News',
    submenu: [
      { name: 'Casino Blogs', path: '/blogs' },
      { name: 'Streaming', path: '/streaming' },
      // { name: 'Casino News', path: '/casino-news' },
    ],
  },
  { name: 'About', path: '/about',
    submenu: [
      { name: 'About Us', path: '/about-us' },
      { name: 'Author', path: '/author' },
      { name: 'Contact Us', path: '/contact' },
    ] },
  {
    name: 'Currency',
    submenu: [
      { name: 'All', path: '/' },
      { name: 'USA', path: '/' },
      { name: 'European', path: '/' },
      { name: 'India', path: '/' },
    ],
  },
];

function App() {
  const location = useLocation();

  useEffect(() => {
    // Track initial pageview
    trackPageView(location.pathname);

    // Cleanup function
    return () => {
      // Add any cleanup logic here if needed
    };
  }, [location.pathname]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100,
    });
  }, []);

  return (
    <Suspense fallback={<div className="w-full h-screen bg-[#1e1e1e] flex justify-center items-center text-white text-2xl">Loading...</div>}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/about-us" element={<AboutUs />} />

        {/* Admin and Auth Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/casinos-admin" element={<CasinosAdmin />} />
        <Route path="/blogs-admin" element={<BlogsAdmin />} />
        <Route path="/settings-admin" element={<SettingsAdmin />} />
        <Route path="/create-casino" element={<CreateCasino />} />
        <Route path="/create-blog" element={<CreateBlog />} />
        <Route path="/edit-casino/:id" element={<EditCasino />} />
        <Route path="/edit-blog/:id" element={<EditBlog />} />
        <Route path="/casino" element={<CasinoDetail />} />
        <Route path="/casinos/:slug" element={<CasinoDetail />} />

        {/* New Menu Routes */}
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/mga-licensed-casinos" element={<MGALicensedCasinos />} />
        <Route path="/kahnawake-licensed-casinos" element={<KahnawakeLicensedCasinos />} />
        <Route path="/curacao-licensed-casinos" element={<CuracaoLicensedCasinos />} />
        <Route path="/casino-games-providers" element={<CasionGamesProviders />} />
        <Route path="/casinos-rewards-casinos" element={<CasinoRewardsCasinos/>} />
        <Route path="/all-dama-nv-casinos" element={<AllDamaNVCasinos />} />
        <Route path="/new-pragmatic-play-casinos" element={<NewPragmaticPlayCasinos />} />
        <Route path="/new-ecopayz-casinos" element={<NewEcopayzCasinos />} />
        <Route path="/paysafecard-true-online-casinos" element={<PaysafecardTrueOnlineCasinos />} />
        <Route path="/best-evolution-gaming-casinos" element={<BestEvolutionGamingCasinos />} />
        <Route path="/rabidi-nv-casinos" element={<RabidiNvCasinos />} />
        <Route path="/casino-details/:name" element={<CasinoDetails />} />
        <Route path="/casino-groups" element={<CasinoGroups />} />
        <Route path="/casino-reviews" element={<CasinoReviews />} />
        <Route path="/providers" element={<Providers />} />
        <Route path="/mobile-casinos" element={<MobileCasinos />} />
        <Route path="/crypto-casinos" element={<CryptoCasinos />} />
        <Route path="/crypto-coins" element={<CryptoCoins />} />
        <Route path="/live-casinos" element={<LiveCasinos />} />
        <Route path="/casinos-by-country" element={<CasinosByCountry />} />
        <Route path="/vpn-casinos" element={<VpnCasinos />} />
        <Route path="/casinos-by-licence" element={<CasinosByLicence />} />
        <Route path="/casinos-by-currency" element={<CasinosByCurrency />} />
        <Route path="/payment-methods" element={<PaymentMethods />} />
        <Route path="/casino-bonuses" element={<CasinoBonuses />} />
        <Route path="/welcome-bonuses" element={<WelcomeBonuses />} />
        <Route path="/no-deposit-bonuses" element={<NoDepositBonuses />} />
        <Route path="/cashback" element={<Cashback />} />
        <Route path="/no-wagering" element={<NoWagering />} />
        <Route path="/high-roller" element={<HighRoller />} />
        <Route path="/reload-bonuses" element={<ReloadBonuses />} />
        <Route path="/bonuses-by-country" element={<BonusesByCountry />} />
        <Route path="/casino-games" element={<CasinoGames />} />
        <Route path="/baccarat-games" element={<BaccaratGames />} />
        <Route path="/blackjack-games" element={<BlackjackGames />} />
        <Route path="/online-poker" element={<OnlinePoker />} />
        <Route path="/slote-games" element={<SloteGames />} />
        <Route path="/roulette-games" element={<RouletteGames />} />
        <Route path="/live-casino-games" element={<LiveCasinoGames />} />
        <Route path="/streaming" element={<Streaming />} />
        <Route path="/about" element={<About />} />
        <Route path="/author" element={<Author />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
<Footer menuItems={menuItems} />
    </Suspense>
  );
}

export default App;
